const closeButtonLabel = "Cerrar";
const esES = {
  closeButtonLabel
};
export {
  closeButtonLabel,
  esES as default
};
